interface CountryCode {
  code: string;
  frenchName: string;
  englishName: string;
}

export const countryCodes: CountryCode[] = [
  { code: "AF", frenchName: "Afghanistan", englishName: "Afghanistan" },
  { code: "AX", frenchName: "Îles Åland", englishName: "Åland Islands" },
  { code: "AL", frenchName: "Albanie", englishName: "Albania" },
  { code: "DZ", frenchName: "Algérie", englishName: "Algeria" },
  { code: "AS", frenchName: "Samoa américaines", englishName: "American Samoa" },
  { code: "AD", frenchName: "Andorre", englishName: "Andorra" },
  { code: "AO", frenchName: "Angola", englishName: "Angola" },
  { code: "AI", frenchName: "Anguilla", englishName: "Anguilla" },
  { code: "AQ", frenchName: "Antarctique", englishName: "Antarctica" },
  { code: "AG", frenchName: "Antigua-et-Barbuda", englishName: "Antigua and Barbuda" },
  { code: "AR", frenchName: "Argentine", englishName: "Argentina" },
  { code: "AM", frenchName: "Arménie", englishName: "Armenia" },
  { code: "AW", frenchName: "Aruba", englishName: "Aruba" },
  { code: "AU", frenchName: "Australie", englishName: "Australia" },
  { code: "AT", frenchName: "Autriche", englishName: "Austria" },
  { code: "AZ", frenchName: "Azerbaïdjan", englishName: "Azerbaijan" },
  { code: "BS", frenchName: "Bahamas", englishName: "Bahamas" },
  { code: "BH", frenchName: "Bahreïn", englishName: "Bahrain" },
  { code: "BD", frenchName: "Bangladesh", englishName: "Bangladesh" },
  { code: "BB", frenchName: "Barbade", englishName: "Barbados" },
  { code: "BY", frenchName: "Biélorussie", englishName: "Belarus" },
  { code: "BE", frenchName: "Belgique", englishName: "Belgium" },
  { code: "BZ", frenchName: "Belize", englishName: "Belize" },
  { code: "BJ", frenchName: "Bénin", englishName: "Benin" },
  { code: "BM", frenchName: "Bermudes", englishName: "Bermuda" },
  { code: "BT", frenchName: "Bhoutan", englishName: "Bhutan" },
  { code: "BO", frenchName: "Bolivie", englishName: "Bolivia" },
  { code: "BA", frenchName: "Bosnie-Herzégovine", englishName: "Bosnia and Herzegovina" },
  { code: "BW", frenchName: "Botswana", englishName: "Botswana" },
  { code: "BV", frenchName: "Île Bouvet", englishName: "Bouvet Island" },
  { code: "BR", frenchName: "Brésil", englishName: "Brazil" },
  { code: "IO", frenchName: "Territoire britannique de l'océan Indien", englishName: "British Indian Ocean Territory" },
  { code: "BN", frenchName: "Brunei Darussalam", englishName: "Brunei Darussalam" },
  { code: "BG", frenchName: "Bulgarie", englishName: "Bulgaria" },
  { code: "BF", frenchName: "Burkina Faso", englishName: "Burkina Faso" },
  { code: "BI", frenchName: "Burundi", englishName: "Burundi" },
  { code: "KH", frenchName: "Cambodge", englishName: "Cambodia" },
  { code: "CM", frenchName: "Cameroun", englishName: "Cameroon" },
  { code: "CA", frenchName: "Canada", englishName: "Canada" },
  { code: "CV", frenchName: "Cap-Vert", englishName: "Cape Verde" },
  { code: "KY", frenchName: "Îles Caïmans", englishName: "Cayman Islands" },
  { code: "CF", frenchName: "République centrafricaine", englishName: "Central African Republic" },
  { code: "TD", frenchName: "Tchad", englishName: "Chad" },
  { code: "CL", frenchName: "Chili", englishName: "Chile" },
  { code: "CN", frenchName: "Chine", englishName: "China" },
  { code: "CX", frenchName: "Île Christmas", englishName: "Christmas Island" },
  { code: "CC", frenchName: "Îles Cocos (Keeling)", englishName: "Cocos (Keeling) Islands" },
  { code: "CO", frenchName: "Colombie", englishName: "Colombia" },
  { code: "KM", frenchName: "Comores", englishName: "Comoros" },
  { code: "CG", frenchName: "Congo", englishName: "Congo" },
  { code: "CD", frenchName: "République démocratique du Congo", englishName: "Democratic Republic of the Congo" },
  { code: "CK", frenchName: "Îles Cook", englishName: "Cook Islands" },
  { code: "CR", frenchName: "Costa Rica", englishName: "Costa Rica" },
  { code: "CI", frenchName: "Côte d'Ivoire", englishName: "Côte d'Ivoire" },
  { code: "HR", frenchName: "Croatie", englishName: "Croatia" },
  { code: "CU", frenchName: "Cuba", englishName: "Cuba" },
  { code: "CW", frenchName: "Curaçao", englishName: "Curaçao" },
  { code: "CY", frenchName: "Chypre", englishName: "Cyprus" },
  { code: "CZ", frenchName: "République tchèque", englishName: "Czech Republic" },
  { code: "DK", frenchName: "Danemark", englishName: "Denmark" },
  { code: "DJ", frenchName: "Djibouti", englishName: "Djibouti" },
  { code: "DM", frenchName: "Dominique", englishName: "Dominica" },
  { code: "DO", frenchName: "République dominicaine", englishName: "Dominican Republic" },
  { code: "EC", frenchName: "Équateur", englishName: "Ecuador" },
  { code: "EG", frenchName: "Égypte", englishName: "Egypt" },
  { code: "SV", frenchName: "Salvador", englishName: "El Salvador" },
  { code: "GQ", frenchName: "Guinée équatoriale", englishName: "Equatorial Guinea" },
  { code: "ER", frenchName: "Érythrée", englishName: "Eritrea" },
  { code: "EE", frenchName: "Estonie", englishName: "Estonia" },
  { code: "ET", frenchName: "Éthiopie", englishName: "Ethiopia" },
  { code: "FK", frenchName: "Îles Malouines", englishName: "Falkland Islands (Malvinas)" },
  { code: "FO", frenchName: "Îles Féroé", englishName: "Faroe Islands" },
  { code: "FJ", frenchName: "Fidji", englishName: "Fiji" },
  { code: "FI", frenchName: "Finlande", englishName: "Finland" },
  { code: "FR", frenchName: "France", englishName: "France" },
  { code: "GF", frenchName: "Guyane française", englishName: "French Guiana" },
  { code: "PF", frenchName: "Polynésie française", englishName: "French Polynesia" },
  { code: "TF", frenchName: "Terres australes et antarctiques françaises", englishName: "French Southern Territories" },
  { code: "GA", frenchName: "Gabon", englishName: "Gabon" },
  { code: "GM", frenchName: "Gambie", englishName: "Gambia" },
  { code: "GE", frenchName: "Géorgie", englishName: "Georgia" },
  { code: "DE", frenchName: "Allemagne", englishName: "Germany" },
  { code: "GH", frenchName: "Ghana", englishName: "Ghana" },
  { code: "GI", frenchName: "Gibraltar", englishName: "Gibraltar" },
  { code: "GR", frenchName: "Grèce", englishName: "Greece" },
  { code: "GL", frenchName: "Groenland", englishName: "Greenland" },
  { code: "GD", frenchName: "Grenade", englishName: "Grenada" },
  { code: "GP", frenchName: "Guadeloupe", englishName: "Guadeloupe" },
  { code: "GU", frenchName: "Guam", englishName: "Guam" },
  { code: "GT", frenchName: "Guatemala", englishName: "Guatemala" },
  { code: "GN", frenchName: "Guinée", englishName: "Guinea" },
  { code: "GW", frenchName: "Guinée-Bissau", englishName: "Guinea-Bissau" },
  { code: "GY", frenchName: "Guyana", englishName: "Guyana" },
  { code: "HT", frenchName: "Haïti", englishName: "Haiti" },
  { code: "HM", frenchName: "Îles Heard et McDonald", englishName: "Heard Island and McDonald Islands" },
  { code: "VA", frenchName: "Saint-Siège", englishName: "Holy See (Vatican City State)" },
  { code: "HN", frenchName: "Honduras", englishName: "Honduras" },
  { code: "HK", frenchName: "Hong Kong", englishName: "Hong Kong" },
  { code: "HU", frenchName: "Hongrie", englishName: "Hungary" },
  { code: "IS", frenchName: "Islande", englishName: "Iceland" },
  { code: "IN", frenchName: "Inde", englishName: "India" },
  { code: "ID", frenchName: "Indonésie", englishName: "Indonesia" },
  { code: "IR", frenchName: "Iran (République islamique d')", englishName: "Iran (Islamic Republic of)" },
  { code: "IQ", frenchName: "Irak", englishName: "Iraq" },
  { code: "IE", frenchName: "Irlande", englishName: "Ireland" },
  { code: "IL", frenchName: "Israël", englishName: "Israel" },
  { code: "IT", frenchName: "Italie", englishName: "Italy" },
  { code: "JM", frenchName: "Jamaïque", englishName: "Jamaica" },
  { code: "JP", frenchName: "Japon", englishName: "Japan" },
  { code: "JO", frenchName: "Jordanie", englishName: "Jordan" },
  { code: "KZ", frenchName: "Kazakhstan", englishName: "Kazakhstan" },
  { code: "KE", frenchName: "Kenya", englishName: "Kenya" },
  { code: "KI", frenchName: "Kiribati", englishName: "Kiribati" },
  { code: "KP", frenchName: "République populaire démocratique de Corée",
    englishName: "Democratic People's Republic of Korea" },
  { code: "KR", frenchName: "République de Corée", englishName: "Republic of Korea" },
  { code: "KW", frenchName: "Koweït", englishName: "Kuwait" },
  { code: "KG", frenchName: "Kirghizistan", englishName: "Kyrgyzstan" },
  { code: "LA", frenchName: "Laos", englishName: "Lao People's Democratic Republic" },
  { code: "LV", frenchName: "Lettonie", englishName: "Latvia" },
  { code: "LB", frenchName: "Liban", englishName: "Lebanon" },
  { code: "LS", frenchName: "Lesotho", englishName: "Lesotho" },
  { code: "LR", frenchName: "Libéria", englishName: "Liberia" },
  { code: "LY", frenchName: "Libye", englishName: "Libya" },
  { code: "LI", frenchName: "Liechtenstein", englishName: "Liechtenstein" },
  { code: "LT", frenchName: "Lituanie", englishName: "Lithuania" },
  { code: "LU", frenchName: "Luxembourg", englishName: "Luxembourg" },
  { code: "MO", frenchName: "Macao", englishName: "Macao" },
  { code: "MK", frenchName: "Macédoine du Nord", englishName: "North Macedonia" },
  { code: "MG", frenchName: "Madagascar", englishName: "Madagascar" },
  { code: "MW", frenchName: "Malawi", englishName: "Malawi" },
  { code: "MY", frenchName: "Malaisie", englishName: "Malaysia" },
  { code: "MV", frenchName: "Maldives", englishName: "Maldives" },
  { code: "ML", frenchName: "Mali", englishName: "Mali" },
  { code: "MT", frenchName: "Malte", englishName: "Malta" },
  { code: "MH", frenchName: "Îles Marshall", englishName: "Marshall Islands" },
  { code: "MQ", frenchName: "Martinique", englishName: "Martinique" },
  { code: "MR", frenchName: "Mauritanie", englishName: "Mauritania" },
  { code: "MU", frenchName: "Maurice", englishName: "Mauritius" },
  { code: "YT", frenchName: "Mayotte", englishName: "Mayotte" },
  { code: "MX", frenchName: "Mexique", englishName: "Mexico" },
  { code: "FM", frenchName: "Micronésie (États fédérés de)", englishName: "Micronesia (Federated States of)" },
  { code: "MD", frenchName: "Moldavie", englishName: "Moldova" },
  { code: "MC", frenchName: "Monaco", englishName: "Monaco" },
  { code: "MN", frenchName: "Mongolie", englishName: "Mongolia" },
  { code: "ME", frenchName: "Monténégro", englishName: "Montenegro" },
  { code: "MS", frenchName: "Montserrat", englishName: "Montserrat" },
  { code: "MA", frenchName: "Maroc", englishName: "Morocco" },
  { code: "MZ", frenchName: "Mozambique", englishName: "Mozambique" },
  { code: "MM", frenchName: "Myanmar", englishName: "Myanmar" },
  { code: "NA", frenchName: "Namibie", englishName: "Namibia" },
  { code: "NR", frenchName: "Nauru", englishName: "Nauru" },
  { code: "NP", frenchName: "Népal", englishName: "Nepal" },
  { code: "NL", frenchName: "Pays-Bas", englishName: "Netherlands" },
  { code: "NC", frenchName: "Nouvelle-Calédonie", englishName: "New Caledonia" },
  { code: "NZ", frenchName: "Nouvelle-Zélande", englishName: "New Zealand" },
  { code: "NI", frenchName: "Nicaragua", englishName: "Nicaragua" },
  { code: "NE", frenchName: "Niger", englishName: "Niger" },
  { code: "NG", frenchName: "Nigéria", englishName: "Nigeria" },
  { code: "NU", frenchName: "Niue", englishName: "Niue" },
  { code: "NF", frenchName: "Île Norfolk", englishName: "Norfolk Island" },
  { code: "MP", frenchName: "Îles Mariannes du Nord", englishName: "Northern Mariana Islands" },
  { code: "NO", frenchName: "Norvège", englishName: "Norway" },
  { code: "OM", frenchName: "Oman", englishName: "Oman" },
  { code: "PK", frenchName: "Pakistan", englishName: "Pakistan" },
  { code: "PW", frenchName: "Palaos", englishName: "Palau" },
  { code: "PS", frenchName: "Territoire palestinien occupé", englishName: "Palestinian Territory, Occupied" },
  { code: "PA", frenchName: "Panama", englishName: "Panama" },
  { code: "PG", frenchName: "Papouasie-Nouvelle-Guinée", englishName: "Papua New Guinea" },
  { code: "PY", frenchName: "Paraguay", englishName: "Paraguay" },
  { code: "PE", frenchName: "Pérou", englishName: "Peru" },
  { code: "PH", frenchName: "Philippines", englishName: "Philippines" },
  { code: "PN", frenchName: "Îles Pitcairn", englishName: "Pitcairn" },
  { code: "PL", frenchName: "Pologne", englishName: "Poland" },
  { code: "PT", frenchName: "Portugal", englishName: "Portugal" },
  { code: "PR", frenchName: "Porto Rico", englishName: "Puerto Rico" },
  { code: "QA", frenchName: "Qatar", englishName: "Qatar" },
  { code: "RE", frenchName: "La Réunion", englishName: "Réunion" },
  { code: "RO", frenchName: "Roumanie", englishName: "Romania" },
  { code: "RU", frenchName: "Fédération de Russie", englishName: "Russian Federation" },
  { code: "RW", frenchName: "Rwanda", englishName: "Rwanda" },
  { code: "BL", frenchName: "Saint-Barthélemy", englishName: "Saint Barthélemy" },
  { code: "SH", frenchName: "Sainte-Hélène", englishName: "Saint Helena" },
  { code: "KN", frenchName: "Saint-Kitts-et-Nevis", englishName: "Saint Kitts and Nevis" },
  { code: "LC", frenchName: "Sainte-Lucie", englishName: "Saint Lucia" },
  { code: "MF", frenchName: "Saint-Martin", englishName: "Saint Martin (French part)" },
  { code: "PM", frenchName: "Saint-Pierre-et-Miquelon", englishName: "Saint Pierre and Miquelon" },
  { code: "VC", frenchName: "Saint-Vincent-et-les-Grenadines", englishName: "Saint Vincent and the Grenadines" },
  { code: "WS", frenchName: "Samoa", englishName: "Samoa" },
  { code: "SM", frenchName: "Saint-Marin", englishName: "San Marino" },
  { code: "ST", frenchName: "Sao Tomé-et-Principe", englishName: "Sao Tome and Principe" },
  { code: "SA", frenchName: "Arabie saoudite", englishName: "Saudi Arabia" },
  { code: "SN", frenchName: "Sénégal", englishName: "Senegal" },
  { code: "RS", frenchName: "Serbie", englishName: "Serbia" },
  { code: "SC", frenchName: "Seychelles", englishName: "Seychelles" },
  { code: "SL", frenchName: "Sierra Leone", englishName: "Sierra Leone" },
  { code: "SG", frenchName: "Singapour", englishName: "Singapore" },
  { code: "SX", frenchName: "Sint Maarten", englishName: "Sint Maarten (Dutch part)" },
  { code: "SK", frenchName: "Slovaquie", englishName: "Slovakia" },
  { code: "SI", frenchName: "Slovénie", englishName: "Slovenia" },
  { code: "SB", frenchName: "Îles Salomon", englishName: "Solomon Islands" },
  { code: "SO", frenchName: "Somalie", englishName: "Somalia" },
  { code: "ZA", frenchName: "Afrique du Sud", englishName: "South Africa" },
  { code: "GS", frenchName: "Géorgie du Sud et les îles Sandwich du Sud",
    englishName: "South Georgia and the South Sandwich Islands" },
  { code: "SS", frenchName: "Soudan du Sud", englishName: "South Sudan" },
  { code: "ES", frenchName: "Espagne", englishName: "Spain" },
  { code: "LK", frenchName: "Sri Lanka", englishName: "Sri Lanka" },
  { code: "SD", frenchName: "Soudan", englishName: "Sudan" },
  { code: "SR", frenchName: "Suriname", englishName: "Suriname" },
  { code: "SJ", frenchName: "Svalbard et Jan Mayen", englishName: "Svalbard and Jan Mayen" },
  { code: "SZ", frenchName: "Swaziland", englishName: "Swaziland" },
  { code: "SE", frenchName: "Suède", englishName: "Sweden" },
  { code: "CH", frenchName: "Suisse", englishName: "Switzerland" },
  { code: "SY", frenchName: "République arabe syrienne", englishName: "Syrian Arab Republic" },
  { code: "TW", frenchName: "Taïwan", englishName: "Taiwan" },
  { code: "TJ", frenchName: "Tadjikistan", englishName: "Tajikistan" },
  { code: "TZ", frenchName: "Tanzanie", englishName: "Tanzania" },
  { code: "TH", frenchName: "Thaïlande", englishName: "Thailand" },
  { code: "TL", frenchName: "Timor-Leste", englishName: "Timor-Leste" },
  { code: "TG", frenchName: "Togo", englishName: "Togo" },
  { code: "TK", frenchName: "Tokelau", englishName: "Tokelau" },
  { code: "TO", frenchName: "Tonga", englishName: "Tonga" },
  { code: "TT", frenchName: "Trinité-et-Tobago", englishName: "Trinidad and Tobago" },
  { code: "TN", frenchName: "Tunisie", englishName: "Tunisia" },
  { code: "TR", frenchName: "Turquie", englishName: "Turkey" },
  { code: "TM", frenchName: "Turkménistan", englishName: "Turkmenistan" },
  { code: "TC", frenchName: "Îles Turques et Caïques", englishName: "Turks and Caicos Islands" },
  { code: "TV", frenchName: "Tuvalu", englishName: "Tuvalu" },
  { code: "UG", frenchName: "Ouganda", englishName: "Uganda" },
  { code: "UA", frenchName: "Ukraine", englishName: "Ukraine" },
  { code: "AE", frenchName: "Émirats arabes unis", englishName: "United Arab Emirates" },
  { code: "GB", frenchName: "Royaume-Uni", englishName: "United Kingdom" },
  { code: "US", frenchName: "États-Unis", englishName: "United States" },
  { code: "UM", frenchName: "Îles mineures éloignées des États-Unis",
    englishName: "United States Minor Outlying Islands" },
  { code: "UY", frenchName: "Uruguay", englishName: "Uruguay" },
  { code: "UZ", frenchName: "Ouzbékistan", englishName: "Uzbekistan" },
  { code: "VU", frenchName: "Vanuatu", englishName: "Vanuatu" },
  { code: "VE", frenchName: "Venezuela (République bolivarienne du)",
    englishName: "Venezuela (Bolivarian Republic of)" },
  { code: "VN", frenchName: "Viêt Nam", englishName: "Viet Nam" },
  { code: "VG", frenchName: "Îles Vierges britanniques", englishName: "Virgin Islands (British)" },
  { code: "VI", frenchName: "Îles Vierges américaines", englishName: "Virgin Islands (U.S.)" },
  { code: "WF", frenchName: "Wallis-et-Futuna", englishName: "Wallis and Futuna" },
  { code: "EH", frenchName: "Sahara occidental", englishName: "Western Sahara" },
  { code: "YE", frenchName: "Yémen", englishName: "Yemen" },
  { code: "ZM", frenchName: "Zambie", englishName: "Zambia" },
  { code: "ZW", frenchName: "Zimbabwe", englishName: "Zimbabwe" },
];
